// components/BrandFooter/index.tsx — business & legal footer (data asli brand_settings; dummy bila kosong; logo wajib)
import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabase/client';
import { getPublicBrandRow } from '../../utils/publicBrandRow';
import type { BusinessInfo } from '../../types';
import { FooterContent, type FooterCollab, type FooterPolicyLink } from './FooterContent';
import { buildBrandFooterData, type BrandFooterData } from './buildData';

export type { FooterCollab, FooterPolicyLink };
export type { BrandFooterData };
export type FooterVariant = 'fisik' | 'digital';

const getCollab = (variant: FooterVariant, isMY: boolean): FooterCollab => ({
  label: isMY ? (variant === 'digital' ? 'Kolaborasi KOL' : 'Kerjasama Produk') : (variant === 'digital' ? 'Kolaborasi KOL' : 'Kerjasama Produk'),
  path: variant === 'digital' ? 'kolaborasi-kol' : 'kerjasama-produk',
});

const POLICY_LINKS_BY_VARIANT: Record<FooterVariant, FooterPolicyLink[]> = {
  fisik: [
    { label: 'Retur & Refund', path: 'retur' },
    { label: 'Pengiriman', path: 'pengiriman' },
    { label: 'Syarat & Ketentuan', path: 'syarat' },
    { label: 'Kebijakan Privasi', path: 'privasi' },
  ],
  digital: [
    { label: 'Retur & Refund', path: 'retur-digital' },
    { label: 'Pengiriman', path: 'pengiriman-digital' },
    { label: 'Syarat & Ketentuan', path: 'syarat-digital' },
    { label: 'Kebijakan Privasi', path: 'privasi-digital' },
  ],
};

const getPolicyLinks = (variant: FooterVariant, isMY: boolean): FooterPolicyLink[] => {
  if (isMY && variant === 'fisik') {
    return [
      { label: 'Pemulangan & Refund', path: 'retur-ms' },
      { label: 'Penghantaran', path: 'pengiriman-ms' },
      { label: 'Terma & Syarat', path: 'syarat-ms' },
      { label: 'Polisi Privasi', path: 'privasi-ms' },
    ];
  }
  return POLICY_LINKS_BY_VARIANT[variant];
};

const BrandFooter: React.FC<{ brandId?: string | null; variant?: FooterVariant; initial?: BrandFooterData | null }> = ({ brandId, variant = 'fisik', initial = null }) => {
  const [data, setData] = useState<BrandFooterData | null>(initial);

  useEffect(() => {
    if (!brandId) return;
    if (initial) return;
    let mounted = true;
        (async () => {
            // S3: RPC per-brand + fallback lama bila migrasi 20261008 belum jalan.
            // Lewat getPublicBrandRow (memo 120 dtk, dipakai bersama warehouse) —
            // footer + gudang form dibuka berbarengan, cukup 1 roundtrip.
            const one = await getPublicBrandRow(brandId).then(r => (r ? [r] : null), () => null);
      const rows = one ? (Array.isArray(one) ? one : [one]) : (await supabase.rpc('get_public_brand_info')).data || [];
      const row = rows.find((r: { brandId: string }) => r.brandId === brandId) || null;
      if (!mounted || !row) return;
      setData(buildBrandFooterData(row));
    })();
    return () => { mounted = false; };
  }, [brandId, initial]);

  if (!data) return null;
  const isMY = data.country === 'MY';

  return <FooterContent data={data} collab={getCollab(variant, isMY)} policyLinks={getPolicyLinks(variant, isMY)} isMY={isMY} />;
};

export default BrandFooter;
